// RocCurve.js
import React from 'react';
import Plot from 'react-plotly.js';

const RocCurve = ({ rocCurve }) => {
  const specificities = rocCurve.map(point => 1 - point.specificity);
  const sensitivities = rocCurve.map(point => point.sensitivity);

  return (
    <div style={{width: '100%'}}>
        <Plot
        data={[
            {
            x: specificities,
            y: sensitivities,
            type: 'scatter',
            mode: 'lines+fills',
            fill: 'tozeroy',
            fillcolor: '#B6BEC190',
            line: { color: '#B6BEC1', width: 2 },
            name: 'ROC Curve'
            }
        ]}
        layout={{
            title: 'ROC Curve',
            xaxis: { title: '1 - Specificity' },
            yaxis: { title: 'Sensitivity' },
            annotations: [
            {
                x: 0.85,
                y: 0.1,
                text: `AUC: ${calculateAUC(rocCurve).toFixed(3)}`,
                showarrow: false,
                font: { family: 'Roboto', size: 14, color: '#26211E' }
            }
            ],
            margin: { l: 45, r: 0, b: 35, t: 45},
            autosize: true
        }}
        config={{ responsive: true }}
        useResizeHandler
        style={{ width: '100%', height: '450px' }}
        />
    </div>
  );
};

// Calculate AUC using trapezoidal rule
const calculateAUC = (rocCurve) => {
  let auc = 0;
  for (let i = 1; i < rocCurve.length; i++) {
    const width = rocCurve[i].specificity - rocCurve[i - 1].specificity;
    const height = (rocCurve[i].sensitivity + rocCurve[i - 1].sensitivity) / 2;
    auc += width * height;
  }
  return auc;
};

export default RocCurve;
